"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisplayBackgroundColor = DisplayBackgroundColor;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@eig-builder/core-ui/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginBottom: theme.spacing(1.5),
      marginTop: theme.spacing(1.5),
      border: '1px solid black'
    }
  };
});

function DisplayBackgroundColor(params) {
  var classes = useStyles(params);
  var value = params.value;
  return value && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root,
    style: {
      background: value
    }
  });
}